import axios from "axios";

const {
    REACT_APP_CLIENTID,
    REACT_APP_MICROSERVICES_URL
} = process.env;

// Check if the user has access
export const useCheckAccess = () => {
    const checkAccess = async (user) => {
        if (!user) {
            console.warn("User data not available.");
            return false;
        }

        try {
            const response = await axios.get(
                `${REACT_APP_MICROSERVICES_URL}/vsecurity/v2/OmniUsers/checkapplication-accessbyuser?clientId=${REACT_APP_CLIENTID}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${user.access_token}`,
                    },
                }
            );

            // Check if the user has access and handle accordingly
            if (!response?.data?.hasAccess) {
                console.warn("Access denied");
                return false;
            }

            return true;
        } catch (error) {
            console.error("Error checking access:", error.response?.data || error.message);
            return false;
        }
    };

    return {checkAccess};
};

// Handle authentication logic
export const useHandleAuthentication = () => {
    const {checkAccess} = useCheckAccess();

    const handleAuthentication = async (user) => {
        if (window.location.pathname !== "/access-denied") {
            // Ensure the user is passed and available
            if (!user) {
                console.error("User object is missing.");
                return;
            }

            const hasAccess = await checkAccess(user);

            if (!hasAccess) {
               window.location.href = "/access-denied";
            }
        }
    };
    return {handleAuthentication};
};